import TabLinksListItem from "components/productCards/TabLinksListItem";
import Product1 from "components/productCards/Product1";
import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { api_private_get } from "script";
import { processBets } from "./productProcessing";
import "./ProductSection.css";
// import { data } from 'jquery';

const ProductSection = () => {
  // State to store API data
  const [marketData, setMarketData] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [searchParams] = useSearchParams();

  const [lastUpdated, setLastUpdated] = useState("Never");

  // Read URL parameter once at render time
  const urlCurrency = searchParams.get("currency");

  const loadProducts = useCallback(() => {
    api_private_get("/market/getDisplayOdds", (data) => {
      console.log(data);

      const markets = processBets(data);

      const products = markets.map((m, idx) => ({
        id: idx + 1,
        name: m.currency,
        imgSrc: `/assets/images/icon/crypto_64x64/${m.currency.toLowerCase()}.png`,
        products: m.products,
      }));

      console.log("Products:", products);

      setMarketData(products);
      setActiveTab((prev) => {
        // Only apply URL parameter if no tab is currently selected (initial load)
        if (
          !prev &&
          urlCurrency &&
          products.some((p) => p.name === urlCurrency)
        ) {
          return urlCurrency;
        }
        // Check if current tab still exists
        const exists = products.some((p) => p.name === prev);
        if (prev && exists) return prev;
        // Default to first product
        return products.length > 0 ? products[0].name : "";
      });

      setLastUpdated(new Date().toLocaleString());
    });
  }, [urlCurrency]);

  useEffect(() => {
    loadProducts();

    // periodically check the products for the selected bet
    const interval = setInterval(() => {
      console.log("Checking for new products...");
      loadProducts();
    }, 5000);

    return () => clearInterval(interval);
  }, [loadProducts]);

  // Handler to change tabs
  const handleTabClick = (tabName) => {
    console.log(`Switching to tab: ${tabName}`);
    setActiveTab(tabName);
  };

  // Function to render products based on active tab
  const renderProducts = () => {
    const activeMarket = marketData.find((market) => market.name === activeTab);

    if (!activeMarket || !activeMarket.products)
      return <p>No products available.</p>;

    return activeMarket.products.map((item) => (
      <Product1
        key={item.title}
        title={item.title}
        icon={activeMarket.imgSrc}
        info1={item.info1}
        info2={item.info2}
        date={item.date}
        starred={item.starred}
        disabled={item.disabled}
        odds={item.odds}
        promotedStrikes={item.promotedStrikes}
      />
    ));
  };

  return (
    <section className="top_matches pb-8 pb-md-10">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 gx-0 gx-lg-4">
            <div className="top_matches__main">
              {/* Crypto Market */}
              <div className="row w-100 mb-8 mb-md-10">
                <div className="col-12">
                  <div className="top_matches__title d-flex align-items-center gap-2 mb-4">
                    <img src="/assets/images/icon/king.png" alt="Icon" />
                    <h3>Crypto Market</h3>
                  </div>
                  <div className="top_matches__content">
                    <div className="singletab">
                      <ul className="tablinks d-flex align-items-center gap-4 flex-wrap mb-5 mb-md-6">
                        {marketData.map((tab) => (
                          <TabLinksListItem
                            key={tab.id}
                            text={tab.name}
                            active={activeTab === tab.name}
                            imgSrc={tab.imgSrc}
                            onClick={() => handleTabClick(tab.name)}
                          />
                        ))}
                      </ul>
                      <div className="mb-5 mx-2">
                        <a
                          href={
                            "/contract-specification/" + activeTab.toLowerCase()
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-underline text-info"
                        >
                          View {activeTab} Contract Specification
                        </a>
                      </div>
                      <div className="tabcontents">
                        <div className="tabitem active">{renderProducts()}</div>
                      </div>
                    </div>
                  </div>
                  <p>Last updated: {lastUpdated}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
